<template>

	<div class="col-xs-12 npd block novedades" v-if="loaded_categorias == 'true'">
		<!-- <h2>NOVEDADES</h2> -->
		<ul class="col-xs-12 filtro" v-if="loaded_categorias=='true'">
			<li class="active">
				<router-link :to="{ name: 'allcats' }" >
					Todos
				</router-link>
			</li>
			<li v-for="categoria in categorias" class="_active">
				<router-link v-if="categoria.slug!='podcast'" :to="{ name: 'cat', params: { name:categoria.slug } }" >
					{{ categoria.name }}
				</router-link>
				<!-- <router-link v-else :to="{ name: 'catpodcast' }" >
					{{ categoria.name }}
				</router-link> -->

			</li>
		</ul>


		<section class="col-xs-12 npd novedades__bloque" v-for="categoria in categorias">
			<div class="container" v-if="categoria.slug!='podcast'">
				<div class="row">
					<div class="col-xs-12 npd novedades__categoria">
						<div class="col-xs-12 col-md-6">
							<!-- <h3><i class="icon musica"></i>Musica</h3> -->
							<h3> {{ categoria.name}}  </h3>
						</div>
						<div class="col-xs-12 col-md-6 text-right">
							<router-link :to="{ name: 'cat', params: { name:categoria.slug } }">
								Ver todo >
							</router-link>
						</div>
					</div>

					<div class="col-xs 12" v-if="loaded_all=='true'">

						<div class="col-xs-6 col-md-3" v-for="post in posts[categoria.id]">
							<router-link :to="{ name: 'post', params: { name:post.slug }}">

								<figure v-if="post.better_featured_image != null">
									<img v-if="post.better_featured_image.media_details.sizes.hasOwnProperty('536x516')" v-bind:src="post.better_featured_image.media_details.sizes['536x516'].source_url" />
									<img v-else v-bind:src="post.better_featured_image.source_url" />
								</figure>
								<figure v-else>
									<img v-bind:src="'http://via.placeholder.com/536x516/008AD2/dddddd?text='+post.title.rendered" alt="">
								</figure>
								<h3 v-html="post.title.rendered">aaaa</h3>
								<p v-html="post.soloexcerpt">aaaa</p>
							</router-link>
						</div>


					</div>
				</div>
			</div>
		</section>

	</div>

</template>

<script>
export default {
	mounted: function() {
		const vm = this;
		vm.getCats();
	},
	watch: {
		// call method if the route changes
		'$route': 'reInitialize'
	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			posts: {},
			loaded: 0,
			loaded_all: 'false',
			loaded_categorias: 'false',
			pageTitle: '',
			totalCount: '',
			total_categorias: -1,
			catName: '',
			LaCat: '',
			categorias:{},
			currentPage: '',
			prevPage: '',
			nextPage: '',
			showNext: 'false',
			showPrev: 'false',
			postPerPage: '4',
			totalPages: '',
		};
	},
	methods: {
		reInitialize: function() {
			this.getCats();
		},
		getPosts: function( catId) {
			const vm = this;
			// vm.loaded[catId] = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: catId, per_page: vm.postPerPage }
			} )
			.then( ( res ) => {
				vm.posts[catId] = res.data;
				vm.loaded++;
				console.log('CARGANDO POSTS CATEGORIA: '+catId);
				vm.$nextTick(function(){
					init_attach();
				});
				console.log(vm.loaded);
				if( (vm.loaded) == (vm.total_categorias) ){
					vm.loaded_all='true';
					console.log('CARGAMOS TODOS');
				}
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		getCats:function (){
			// http://104.236.216.165/wp-json/wp/v2/categories/
			const vm = this;
			vm.loaded_categorias = 'false';
			vm.$http.get( 'wp/v2/categories/', {
				params: { hide_empty: true, parent:0 }
			} )
			.then( ( res ) => {
				vm.loaded_categorias='true';
				vm.categorias=res.data;
				console.log('TOTAL CATEGORIAS == '+res.data.length);
				vm.total_categorias=res.data.length;
				Object.keys(res.data).map(function(objectKey, index) {
					var value = res.data[objectKey];
					vm.getPosts(value.id);
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		}
	},
};
</script>



// WEBPACK FOOTER //
// allcats.vue?79361ce1